import * as React from "react";
import Home from "./Dashboard/components/pages/home/Home";
import "./HomePage.css";

const HomePage = () => {
    return (
        <>
            <div className="container">
                <Home/>
            </div>
        </>
    );
}

export default HomePage;